import {
	AfterViewChecked,
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild
} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Message } from 'src/app/shared/models/message';
import { MessageNotification } from 'src/app/shared/models/message-notification';
import { Conversation } from 'src/app/shared/models/messaging/conversation';
import { User } from 'src/app/shared/models/security/user';
import { AddConversationComponent } from '../add-conversation/add-conversation.component';

@Component({
	selector: 'app-browser-messagerie',
	templateUrl: './browser-messagerie.component.html',
	styleUrls: ['./browser-messagerie.component.scss']
})
export class BrowserMessagerieComponent implements OnChanges {
	@Input() conversations: Conversation[] = [];
	@Input() notifications: MessageNotification[] = [];
	@Input() isSendButtonDisabled: boolean = false;
	@Input() currentUser: User;
	@Input() usersForNewConversation: User[];
	@Output() sendMessageEmitter: EventEmitter<any> = new EventEmitter();

	// Index de la conversation active dans la liste des conversations existantes
	currentConversationIndex: number = 0;

	searchedInput: string = '';

	// Liste des messages actuellement affichée
	currentMessageList: Message[] = [];
	currentReceiverUser: User;

	@ViewChild('scrollContainer') private scrollContainer: ElementRef;

	// Contenu du message à envoyer
	currentMessage: string = '';

	/**
	 * Modal d'ajout d'une nouvelle conversation
	 */
	addNewConvModalRef: BsModalRef;

	constructor(
		private facadeService: FacadeService,
		private modalService: BsModalService
	) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.conversations && !changes.conversations.isFirstChange()) {
			if (
				changes.conversations.previousValue.length !==
				changes.conversations.currentValue.length
			) {
				this.changeActiveConversation(0);
			}
		}
	}

	changeActiveConversation(newIndex: number) {
		this.currentConversationIndex = newIndex;
		this.currentReceiverUser = this.conversations[newIndex].user;
		this.currentMessageList = this.conversations[newIndex].messageList;

		// On retire les notifications liées à l'user sur lequel on a cliqué
		this.notifications = this.notifications.filter(
			(notification) => notification.idSender !== this.currentReceiverUser.id
		);
		// Et on envoi au back l'ordre de reset le compteur de notification
		this.clearUserNotification();

		// On déclenche l'update automatique des messages de la conversation
		this.facadeService.messageService.ngOnDestroy(); // en détruisant l'ancienne update auto (lié à l'ancien user)
		this.updateConversationAndReload(this.currentReceiverUser);
	}

	clearUserNotification() {
		// this.facadeService.notificationService
		// 	.clearMessageNotification(
		// 		this.currentReceiverUser.id,
		// 		this.currentUser.id
		// 	)
		// 	.subscribe(() => {});
	}

	updateConversationAndReload(userReceiver) {
		if (userReceiver !== null) {
			this.facadeService.messageService
				.getAllMessageByIdSenderAndIdReceiverReload(
					this.currentUser.id,
					userReceiver.id
				)
				.subscribe((messagesList: Message[]) => {
					this.currentMessageList = messagesList;
				});
		}
	}

	getLastMessageOfConversation(conversation: Conversation) {
		return conversation.messageList.length > 0
			? conversation.messageList[conversation.messageList.length - 1]
			: null;
	}

	getLastMessageContentFormatted(conversation: Conversation) {
		if (!this.getLastMessageOfConversation(conversation)) {
			return '';
		}
		return this.getLastMessageOfConversation(conversation).messageContent
			.length > 25
			? this.getLastMessageOfConversation(conversation).messageContent.slice(
					0,
					25
			  ) + '...'
			: this.getLastMessageOfConversation(conversation).messageContent;
	}

	scrollToBottom() {
		try {
			// mise à jour de la taille du scroll
			this.scrollContainer.nativeElement.scrollTop =
				this.scrollContainer.nativeElement.scrollHeight;
			// scroll
			this.scrollContainer.nativeElement.scrollIntoView();
		} catch (err) {}
	}

	sendMessage() {
		const message = new Message({
			idSender: this.currentUser.id,
			idReceiver: this.currentReceiverUser.id,
			messageContent: this.currentMessage,
			createdAt: new Date()
		});

		this.sendMessageEmitter.emit(message);
	}

	/**
	 * Le message a bien été reçu par le back end, on peut l'ajouter à la liste
	 * @param message
	 */
	messageReachedBackConfirmed(message: Message) {
		this.currentMessageList.push(message);
		this.currentMessage = '';
	}

	createNewConversation() {
		const initialState = {
			usersForNewConversation: this.usersForNewConversation,
			conversations: this.conversations
		};
		this.addNewConvModalRef = this.modalService.show(AddConversationComponent, {
			class: 'modal-lg',
			initialState,
			backdrop: 'static'
		});

		this.addNewConvModalRef.onHide.subscribe((reason: string | any) => {
			if (this.addNewConvModalRef.content.user) {
				const conv = new Conversation();
				conv.user = this.addNewConvModalRef.content.user;
				conv.messageList = [];
				this.conversations.push(conv);

				this.changeActiveConversation(this.conversations.length - 1);
			}
		});
	}
}
